import React, { Component } from 'react';
import styles from './loading.module.scss';
import PropTypes from 'prop-types';
class Loading extends Component {
  render() {
    const text = this.props.children || 'Loading';
    return (
      <div className={styles.loading}>
        {text} <span className={styles.loadingCircle} />{' '}
      </div>
    );
  }
}
Loading.propTypes = {
  children: PropTypes.node,
};
export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/loading.js